import { ResultsPanel } from "@omni/components/components/Search/SearchBar/components/ResultsPanel/resultsPanel";
import { SearchBar } from "@omni/components/components/Search/SearchBar/searchBar";
import { useGranite } from "@omni/components/redux/modules/value/translations/translations.provider";
import { cn } from "@omni/utils/styles";

export const ResultsPanelComponent = () => {
    const { t } = useGranite();
    const { autocompleteState } = SearchBar.useContext();

    return (
        <ResultsPanel.Panel
            className={cn(
                "tw:mt-4 tw:pt-4 tw:bg-white tw:flex tw:flex-col tw:border-t tw:border-divider tw:overflow-auto tw:h-full tw:pb-8",
                "tw:lg:grid tw:lg:gap-4 tw:lg:grid-cols-[9fr_16fr] tw:lg:border-none tw:lg:pt-0 tw:lg:overflow-visible tw:h-auto tw:lg:pb-0 tw:lg:-mx-4 tw:lg:p-8 tw:lg:rounded-xl"
            )}
        >
            <ResultsPanel.NoResults />
            <ResultsPanel.Results>
                <div className={cn("tw:min-w-0 tw:flex tw:flex-col tw:gap-3")}>
                    <ResultsPanel.Results.RecentSearches>
                        <div
                            className={
                                "tw:text-2xl tw:font-bold tw:font-gravity tw:italic tw:uppercase tw:mb-3"
                            }
                        >
                            {t("searchBox.panel.recentSearches.header.title")}
                        </div>
                        <ResultsPanel.Results.RecentSearches.Items>
                            <ResultsPanel.Results.RecentSearches.Item />
                        </ResultsPanel.Results.RecentSearches.Items>
                    </ResultsPanel.Results.RecentSearches>
                    <ResultsPanel.Results.QuerySuggestions>
                        <div
                            className={
                                "tw:text-2xl tw:font-bold tw:font-gravity tw:italic tw:uppercase tw:mb-3"
                            }
                        >
                            {t("searchBox.panel.querySuggestions.header.title")}
                        </div>
                        <ResultsPanel.Results.QuerySuggestions.Items>
                            <ResultsPanel.Results.QuerySuggestions.Item />
                        </ResultsPanel.Results.QuerySuggestions.Items>
                    </ResultsPanel.Results.QuerySuggestions>
                    <ResultsPanel.Results.ContentPages>
                        <div
                            className={
                                "tw:text-2xl tw:font-bold tw:font-gravity tw:italic tw:uppercase tw:mb-3"
                            }
                        >
                            {t("searchBox.panel.contentPages.header.title")}
                        </div>
                        <ResultsPanel.Results.ContentPages.Items>
                            <ResultsPanel.Results.ContentPages.Item />
                        </ResultsPanel.Results.ContentPages.Items>
                    </ResultsPanel.Results.ContentPages>
                </div>
                <div className={cn("tw:min-w-0 tw:flex tw:flex-col tw:gap-3")}>
                    <ResultsPanel.Results.Products>
                        <div
                            className={cn(
                                "tw:flex tw:justify-between tw:content-center tw:mb-3"
                            )}
                        >
                            <div
                                className={
                                    "tw:text-2xl tw:font-bold tw:font-gravity tw:italic tw:uppercase"
                                }
                            >
                                {autocompleteState?.query?.length === 0
                                    ? t(
                                          "searchBox.panel.products.header.title.emptyQuery"
                                      )
                                    : t(
                                          "searchBox.panel.products.header.title.querying"
                                      )}
                            </div>
                            <ResultsPanel.Results.Products.ShowAllButton
                                color={"link"}
                                className={cn("tw:p-0")}
                            />
                        </div>
                        <ResultsPanel.Results.Products.Items>
                            <ResultsPanel.Results.Products.Item />
                        </ResultsPanel.Results.Products.Items>
                    </ResultsPanel.Results.Products>
                </div>
            </ResultsPanel.Results>
        </ResultsPanel.Panel>
    );
};
